import React, { useEffect, useState } from "react";
import {GoSearch, } from "react-icons/go";
import { FiAlignJustify } from "react-icons/fi";
// import { Link } from "react-router-dom";
import "../Components/MyDocuments/MyDocuments.css"
import Popup from "reactjs-popup";
import 'reactjs-popup/dist/index.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import axios from "axios";
import { tcRatingToLetter } from "../Components/MyDocuments/RatingConverter.js";
import * as FaIcons from "react-icons/fa";


const MyDocuments = () => {
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  const { isAuth, user } = useSelector((state) => state.user);
  const [docNameId, docCompanyId, docTypeId, docUploadDateId, docDateSignedId, docRatingId] = [0,1,2,3,4,5];
  const [popupOpen, setPopupOpen] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  /*
    Active tab:
    Positive number means how to sort/Negative number means reverse the sort
    0: order of documents in file
    1: sort by document name
    2: sort by document type
    3: sort by upload date
    4: sort by document rating
  */
  const [activeTab, setActiveTab] = useState(docUploadDateId);
  const [activePage, setPage] = useState(0);
  const [searchName, setSearchName] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [startDoc, setStartDoc] = useState(0);
  const [list, setList] = useState([]);
  const [completeList, setCompleteList] = useState([]);
  const [popupDoc, setPopupDoc] = useState(list[0]);  

  useEffect(() => {
    if (isAuth && user && user.preferences) {
      const textSize = user.preferences.textSize;

      switch (textSize) {
        case 0: // Small
          document.documentElement.style.setProperty('--font-size-title', '1.5vw');
          document.documentElement.style.setProperty('--font-size-input', '14px');
          document.documentElement.style.setProperty('--font-size-table-heading', '0.8vw');
          document.documentElement.style.setProperty('--font-size-upload-btn', '0.8vw');
          break;
        case 1: // Medium (default)
          document.documentElement.style.setProperty('--font-size-title', '2vw');
          document.documentElement.style.setProperty('--font-size-input', '16px');
          document.documentElement.style.setProperty('--font-size-table-heading', '1vw');
          document.documentElement.style.setProperty('--font-size-upload-btn', '1vw');
          break;
        case 2: // Large
          document.documentElement.style.setProperty('--font-size-title', '3vw');
          document.documentElement.style.setProperty('--font-size-input', '24px');
          document.documentElement.style.setProperty('--font-size-table-heading', '2vw');
          document.documentElement.style.setProperty('--font-size-upload-btn', '2vw');
          break;
        default:
          break;
      }
    } else if (!isAuth) { 
      document.documentElement.style.setProperty('--font-size-title', '2vw');
      document.documentElement.style.setProperty('--font-size-input', '16px');
      document.documentElement.style.setProperty('--font-size-table-heading', '1vw');
      document.documentElement.style.setProperty('--font-size-upload-btn', '1vw');
    }
  }, [user, isAuth]);

  const updateDocs = async () => {
    axios({
      method: 'get',
      url: 'api/v1/tcs/mydocs',
      baseURL: '/',
    })
    .then((response) => {
      const copyListOfDocs = [...(response.data.docs)];
      copyListOfDocs.sort((a,b) => {
        if (a.dateUploaded < b.dateUploaded) return 1;
        if (a.dateUploaded > b.dateUploaded) return -1;
        return 0;
      })
      setList(copyListOfDocs);
      setCompleteList(copyListOfDocs);
      // console.log(copyListOfDocs);
      setActiveTab(0);
      setPage(0);
      setSearchName("");
      setStartDoc(0);
    })
    .catch(function (error){
      console.log("error getting docs");
    });
  }

  useEffect(() => {
    if (!isAuth) {
      navigate('/');
    }
    if (isAuth && user) {
      updateDocs();
      // axios.get('api/v1/tcs/mydocs')
      // .then((response) => {
      //   updateDocs();
      // })
      // .catch(function (error){
      //   console.log("error getting docs");
      // });
    }
  }, [isAuth, user, navigate]);

  const getActiveTab = () => {
    return activeTab;
  }

  let docsFound = 0;
  const pageList = [];
  for (let i = 0; i < Math.ceil(list.length/10); i++) {
    pageList.push(i);
  }

  const handleSearch = () => {
    setSearchName(searchKey);
    setList(completeList.filter(doc => (doc.name.toLowerCase().includes(searchKey.toLowerCase()))));
    handlePageBtn(0);
  }

  const handleSearchEnter = (e) => {
    if (e.code === "Enter"){
      setSearchName(searchKey);
      console.log(searchKey);
      setList(completeList.filter(doc => (doc.name.toLowerCase().includes(searchKey.toLowerCase()))));
      handlePageBtn(0);
    }
  }

  const handleSearchUpdate = (name) => {
    setSearchKey(name);
  }

  const handleSortByName = () => {
    console.log("Sort by document name for docID " + docNameId);
    const copyList = [...list];
    
    if (activeTab === docNameId) {
      copyList.reverse();
    } else {
      setActiveTab(docNameId);
      copyList.sort((a,b) => {
        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByCompany = () => {
    console.log("Sort by document company");
    const copyList = [...list];
    
    if (activeTab === docCompanyId) {
      copyList.reverse();
    } else {
      setActiveTab(docCompanyId);
      copyList.sort((a,b) => {
        if(a.company.toLowerCase() < b.company.toLowerCase()) return -1;
        if(a.company.toLowerCase() > b.company.toLowerCase()) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByType = () => {
    console.log("Sort by document type");
    const copyList = [...list];
    
    if (activeTab === docTypeId) {
      copyList.reverse();
    } else {
      setActiveTab(docTypeId);
      copyList.sort((a,b) => {
        if(a.contractType.toLowerCase() < b.contractType.toLowerCase()) return -1;
        if(a.contractType.toLowerCase() > b.contractType.toLowerCase()) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByUploadDate = () => {
    console.log("Sort by upload date");
    const copyList = [...list];
    
    if (activeTab === docUploadDateId) {
      copyList.reverse();
    } else {
      setActiveTab(docUploadDateId);
      copyList.sort((a,b) => {
        if (a.dateUploaded < b.dateUploaded) return 1;
        if (a.dateUploaded > b.dateUploaded) return -1;
        // if(a.uploadYear < b.uploadYear) return 1;
        // if(a.uploadYear > b.uploadYear) return -1;
        // if(a.uploadMonth < b.uploadMonth) return 1;
        // if(a.uploadMonth > b.uploadMonth) return -1;
        // if(a.uploadDay < b.uploadDay) return 1;
        // if(a.uploadDay > b.uploadDay) return -1;
        return 0;
      })
    }
    
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByDateSigned = () => {
    console.log("Sort by signed date");
    const copyList = [...list];
    
    if (activeTab === docDateSignedId) {
      copyList.reverse();
    } else {
      setActiveTab(docDateSignedId);
      copyList.sort((a,b) => {
        if (a.dateSigned === undefined) {
          if (b.dateSigned === undefined) {
            if (a.dateUploaded < b.dateUploaded) return 1;
            if (a.dateUploaded > b.dateUploaded) return -1;
            // if(a.uploadYear < b.uploadYear) return 1;
            // if(a.uploadYear > b.uploadYear) return -1;
            // if(a.uploadMonth < b.uploadMonth) return 1;
            // if(a.uploadMonth > b.uploadMonth) return -1;
            // if(a.uploadDay < b.uploadDay) return 1;
            // if(a.uploadDay > b.uploadDay) return -1;
            return 0;
          }
          return 1;
        }
        if (b.dateSigned === undefined) { 
          return -1;
        }
        if(a.dateSigned < b.dateSigned) return 1;
        if(a.dateSigned > b.dateSigned) return -1;
        
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  const handleSortByRating = () => {
    console.log("Sort by document rating");
    const copyList = [...list];
    
    if (activeTab === docRatingId) {
      copyList.reverse();
    } else {
      setActiveTab(docRatingId);
      copyList.sort((a,b) => {
        if(a.tcRating < b.tcRating) return -1;
        if(a.tcRating > b.tcRating) return 1;
        return 0;
      })
    }
    setPage(0);
    setStartDoc(0);
    setList(copyList);
  }

  // const handleOpenDoc = (v, index) => {
  // }

  const handleView = (docid) => {
    navigate(`/analysis/${docid}`);
  }

  function getDoc() {
    return popupDoc;
  }

  const updateDoc = ( doc ) => {
    const ind = list.findIndex((d) => (d._id === doc._id));
    // console.log(ind);
    if ((-1 < ind) && (ind < list.length)){
      // console.log("whyyyyy");
      let newList = [...list];
      // console.log(newList);
      newList[ind] = doc;
      // console.log(newList);
      setList(newList);
      setCompleteList(newList);
    }
  }

  const removeDoc = ( docid ) => {
    const ind = list.findIndex((d) => (d._id === docid));

    if ((-1 < ind) && (ind < list.length)){
      // console.log("whyyyyy");
      let newList = list.toSpliced(ind, 1);
      console.log(newList);
      setList(newList);
      setCompleteList(newList);
    }
  }

  // Select Page buttons
  const handlePrevBtn = () => {
    handlePageBtn(activePage-(activePage % 5) - 1);
  }
  const handleNextBtn = () => {
    handlePageBtn(activePage - (activePage % 5) + 5);
  }
  const handlePageBtn = (index) => {
    setPage(index);
    setStartDoc(index*10);
    docsFound = 0;
  }

  return (
    <div className="myDocuments">
      <h1>My Documents</h1>
      <div className="search">
        <div className="searchBar">
          <input className="searchText" id="searchText" placeholder="Search My Documents"
            onChange={e => handleSearchUpdate(e.target.value)} onKeyDown={e => handleSearchEnter(e)}></input>
            <GoSearch className="searchIcon" onClick={handleSearch}/>
        </div>
        <table className="searchTable">
          <thead key="tableHead">
            <tr className="tableRowHeading" key="heading">
              <th className="nameTab" key={"DocName"} isactive={docNameId===Math.abs(activeTab)}>
                <Tab id={docNameId} sort={handleSortByName} type={"Name"} activeTab={getActiveTab}/></th>
              <th className="companyTab" key={"CompanyName"} isactive={docCompanyId===Math.abs(activeTab)}>
                <Tab id={docCompanyId} sort={handleSortByCompany} type={"Company"} activeTab={getActiveTab}/></th>
              <th className="typeTab" key={"DocType"} isactive={docTypeId===Math.abs(activeTab)}>
                <Tab id={docTypeId} sort={handleSortByType} type={"Type"} activeTab={getActiveTab}/></th>
              <th className="uploadTab" key={"DocUpload"} isactive={docUploadDateId===Math.abs(activeTab)}>
                <Tab id={docUploadDateId} sort={handleSortByUploadDate} type={"Upload Date"} activeTab={getActiveTab}/></th>
              <th className="signedTab" key={"DocSigned"} isactive={docDateSignedId===Math.abs(activeTab)}>
                <Tab id={docDateSignedId} sort={handleSortByDateSigned} type={"Date Signed"} activeTab={getActiveTab}/></th>
              <th className="ratingTab" key={"DocRating"} isactive={docRatingId===Math.abs(activeTab)}>
                <Tab id={docRatingId} sort={handleSortByRating} type={"Rating"} activeTab={getActiveTab}/></th>
            </tr>
          </thead>

          <tbody key="tableBody">
            {/* eslint-disable-next-line */}
            {list.length > 0 && list.map((doc, index) => {
              if (docsFound < 10 && startDoc <= index) {
                if (doc.name.toLowerCase().includes(searchName.toLowerCase())) {
                  docsFound++;
                  return (
                    <tr className="tableRow" key={"Row"+index}>
                      <td className="nameTab" key={"name"+index}>{doc.name}</td>
                      <td className="companyTab" key={"company"+index}>{doc.company}</td>
                      <td className="typeTab" key={"type"+index}>{doc.contractType}</td>
                      <td className="uploadTab" key={"upload"+index}>
                        {((new Date(doc.dateUploaded)).getMonth()+1) +"/"+ (new Date(doc.dateUploaded)).getDate() +"/" + (new Date(doc.dateUploaded)).getFullYear() }</td>
                      <td className="signedTab" key={"signed"+index}>
                        {doc.dateSigned !== undefined ? ((new Date (doc.dateSigned)).getMonth()+1) +"/"+ (new Date(doc.dateSigned)).getDate() +"/"+(new Date(doc.dateSigned)).getFullYear() : "X"}</td>
                      <td className="optionsTab" key={doc.tcRating+doc._id+index}>{tcRatingToLetter(doc.tcRating)}</td>
                      <td className="popupTD"key={"Icon"+doc._id}>
                      <Popup className="docEdit" onOpen={()=>{ setPopupDoc(doc) }} contentStyle={{width: "10%"}} trigger= 
                          {<button className="pageEditList"><FiAlignJustify/></button>}>{
                          close => (
                              <div className="modal">
                                  <li className="pageEditBtns" onClick={() => handleView(doc._id)}>View</li>
                                  <li className="pageEditBtns" onClick={()=>setPopupOpen(true)}>Edit</li>
                                  <li className="pageEditBtns" onClick={()=>setIsOpenDelete(true)}>Delete</li>
                                  <li className="pageEditBtns">Share</li>
                                  <li className="pageEditBtns">Download</li>
                              </div>
                              )
                          }
                        </Popup>
                      </td>
                    </tr>
                  );
                }
              }
            })}
          </tbody>
        </table>

        {EditPopUp(getDoc(), updateDoc, popupOpen, setPopupOpen)}
        {DeletePopUp(getDoc(), removeDoc, isOpenDelete, setIsOpenDelete)}

        <div className="pageBtns">
          <button className="myDocUploadBtn" onClick={() => navigate("/upload")}>Upload New Document</button>
         
          <div className="pageBtnList">
            <p className={activePage < 5 ? "pageBtn inactive" : "pageBtn"} key={"prevBtn"} onClick={handlePrevBtn}>Prev</p>
            {/* eslint-disable-next-line */}
            {pageList.length > 0 && pageList.map((element) => {
              if (activePage - (activePage % 5) <= element && element <= activePage - (activePage % 5) + 4) {
                return <p className={element === activePage ? "pageBtn active" : "pageBtn"} key={"page"+(element+1)}
                  onClick={()=>handlePageBtn(element)}>{element + 1}</p>;
              }
            })}
            <p className={(activePage - activePage % 5) + 5 >= pageList.length ? "pageBtn inactive" : "pageBtn"}
              key={"nextBtn"} onClick={handleNextBtn}>Next</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const DeletePopUp = (doc, removeDoc, isOpenDelete, setIsOpenDelete) => {
  return  <Popup open={isOpenDelete} on="click" onClose={() => setIsOpenDelete(false)} modal nested>
  {close => (
      <div className="modal">
      <div className="header">Are you sure you want to delete this document?</div>
      <div className="actions">
          <button
          className="yes-button"
          onClick={() => {
              axios({
                method: 'delete',
                url: `api/v1/tcs/delete/${doc._id}`,
                baseURL: '/',
              })
              .then((response) => {
                if (response.data.success){
                  removeDoc(doc._id);
                } else {
                  alert('Failed to delete document');
                }
              })
              .catch(function (error) {
                if (error.response) {
                  //request made and server rejected it
                  alert(`${error.response.status}: ${error.response.data.message}`);
                } else if (error.request){
                  //request made but no response received
                  alert("No response from server");
                } else {
                  //some other problem while setting up the request
                  alert("Error setting up request");
                }
              });

              setIsOpenDelete(false);
          }}
          >
          Yes
          </button>
          <button className="no-button" onClick={()=>setIsOpenDelete(false)}>
          No
          </button>
      </div>
      </div>
  )}
</Popup>
}

const EditPopUp = (doc, updateDoc, popupOpen, setPopupOpen) => {
  if (doc === undefined) {
    return;
  }
  // console.log(doc);
  let signedDate = null;

  if (doc.dateSigned !== undefined) {
    let date = new Date(doc.dateSigned);
    const y = date.getFullYear();
    const m = (date.getMonth()+1) <= 9 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
    const d = date.getDate() <= 9 ? "0"+date.getDate() : date.getDate();
    signedDate = (y + "-" + m + "-" + d);
  }

  let expirationDate = null;

  if (doc.expiryDate !== null) {
    let date = new Date(doc.expiryDate);
    const y = date.getFullYear();
    const m = (date.getMonth()+1) <= 9 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
    const d = date.getDate() <= 9 ? "0"+date.getDate() : date.getDate();
    expirationDate = (y + "-" + m + "-" + d);
  }

  let popupActive = doc.hasOwnProperty("active") ? doc.active : false;

  let [popupName, popupType, popupProduct, popupCompany, popupSigned, popupExpire] = [doc.name, doc.contractType, doc.product, doc.company, signedDate, expirationDate];

  const saveContractDetails = () => {
    let newData = {};
    newData.name = popupName;
    newData.contractType = popupType;
    newData.product = popupProduct;
    newData.company = popupCompany;
    newData.active = popupActive;
    
    if (popupSigned) {
      let date = new Date(popupSigned + "T00:00");
      newData.dateSigned = date.toISOString();
    }
    if (popupExpire) {
      let date = new Date(popupExpire + "T00:00");
      newData.expiryDate = date.toISOString();
    }

    axios
      .put(`api/v1/tcs/update/${doc._id}`, newData)
      .then((response) => {
        if (response.data.success){
          updateDoc(response.data.usertc);
        } else {
          console.log('Error retrieving UserTC');
        }
      })
      .catch(function (error) {
        if (error.response) {
          console.log(`${error.response.status}: ${error.response.data.message}`);
        } else if (error.request){
          console.log("No response from server");
        } else {
          console.log("error setting up request");
        }
      });
    setPopupOpen(false);
  }

  return (
    <Popup className="ratingKeyPopUp" contentStyle={{width: "60%"}} open={popupOpen} on="click" onClose={()=>setPopupOpen(false)}
    modal nested>
    {
        close => (
            <div className="editContractPopup">
                <div className="changeInfo">
                    <label><span>Document Name:</span><input id="nameInput" type="text" defaultValue={doc.name} onChange={(e)=> popupName = e.target.value}/></label>
                                        <label><span>Contract Type:</span><input id="typeInput" type="text" defaultValue={doc.contractType} onChange={(e)=> popupType = e.target.value}/></label>
                                        <label><span>Product:</span><input id="productInput" type="text" defaultValue={doc.product} onChange={(e)=> popupProduct = e.target.value}/></label>
                                        <label><span>Company:</span><input id="companyInput" type="text" defaultValue={doc.company} onChange={(e)=> popupCompany = e.target.value}/></label>
                    <h2 className="saveDetails" onClick={()=>saveContractDetails()}>Save</h2>
                </div>
                <div className="signedDate">
                    <label><span>Signed On:</span><input className="dateSelect" type="date" defaultValue={signedDate} onChange={e=> popupSigned = e.target.value}/></label>
                    <label><span>Expires on:</span><input className="dateSelect" type="date" defaultValue={expirationDate} onChange={e=> popupExpire = e.target.value}/></label>
                    <label>Active:<input type="checkbox" name="active" defaultChecked={popupActive} onChange={(e) => popupActive = e.target.checked}/></label>
                </div>
            </div>
        )
    }
  </Popup>);
}

const Tab = ({id, sort, type, activeTab}) => {
  // [INACTIVE, DOWN, UP ] = [0,1,2]
  const [active, setActive] = useState(0);
  const handleClick = (e) => {
    sort();
    setActive(e);
  }
  if (activeTab() !== id && active !== 0) {
    setActive(0);
    return <span onClick={()=>handleClick(1)}>{type}<FaIcons.FaSort/></span>;
  }
  if (activeTab() === id) {
    if (active === 1) {
      return <span onClick={()=>handleClick(2)}>{type}<FaIcons.FaCaretDown/></span>;
    }
    if (active === 2){
      return <span onClick={()=>handleClick(1)}>{type}<FaIcons.FaCaretUp/></span>;
    }
  }
  return <span onClick={()=>handleClick(1)}>{type}<FaIcons.FaSort/></span>;
}


export default MyDocuments;